var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "w-full" }, [
      _c("label", { attrs: { for: "phone" } }, [
        _vm._v(_vm._s(_vm.step.label)),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.trim",
            value: _vm.inputData,
            expression: "inputData",
            modifiers: { trim: true },
          },
        ],
        staticClass: "input-styling",
        attrs: { placeholder: _vm.step.placeholder },
        domProps: { value: _vm.inputData },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.inputData = $event.target.value.trim()
            },
            _vm.updateParentValue,
          ],
          blur: function ($event) {
            return _vm.$forceUpdate()
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "error-text-styling" }, [
      _vm.displayErrorMessage
        ? _c("div", [
            _vm._v(
              "\n            " + _vm._s(_vm.step.errorMessage) + "\n        "
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }